import { render, staticRenderFns } from "./MyTags.vue?vue&type=template&id=2867bc96&"
import script from "./MyTags.vue?vue&type=script&lang=js&"
export * from "./MyTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports